import SEO from '@/components/SEO';
import { Layout } from '@/components/layout/Layout';
import { HeroSection } from '@/components/home/HeroSection';
import { QuickInfoSection } from '@/components/home/QuickInfoSection';
import { TodaysLunchSection } from '@/components/home/TodaysLunchSection';
import { LunchCardPromo } from '@/components/home/LunchCardPromo';

const Index = () => {
  return (
    <Layout>
      <SEO 
        structuredData={{
          "@context": "https://schema.org",
          "@type": "Restaurant",
          "name": "Restaurang CFL",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Södra Järnvägsgatan 7",
            "addressLocality": "Söderhamn",
            "postalCode": "826 31",
            "addressCountry": "SE"
          },
          "telephone": "+46737825761",
          "url": "https://restaurangcfl.se",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": [
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday"
              ],
              "opens": "08:00",
              "closes": "15:00"
            }
          ],
          "servesCuisine": "Husmanskost, Lunch",
          "email": "kontakt@cfl.se"
        }}
      />
      <HeroSection />
      <TodaysLunchSection />
      {/* <LunchCardPromo /> */}
      <QuickInfoSection />
    </Layout>
  );
};

export default Index;
